import { CreateAdminBankRequest } from "@features/admin/banks/api";
import * as yup from "yup";

export const bankSchema: yup.ObjectSchema<CreateAdminBankRequest> = yup
  .object()
  .shape({
    alias: yup.string().required().trim(),
    bank_id_code: yup.string().required().trim(),
    logo: yup.string().trim(),
    name: yup.string().required().trim(),
    phone_number: yup.string().trim(),
    push_notification_packages: yup.array().of(yup.string().required().trim()),
    regexes: yup
      .array()
      .of(
        yup.object({
          regex: yup.string().required(),
          type: yup.string().required().trim(),
          method: yup.string().required().trim(),
          description: yup.string().required().trim(),
        })
      )
      .required(),
    region: yup
      .object({
        id: yup.number(),
      })
      .notRequired(),
    require_account_for_sbp: yup.boolean(),
    uniq_only: yup.boolean(),
    country: yup.string().trim(),
    currency: yup.string().trim(),
    type: yup.string().trim(),
    method: yup.string().trim(),
  });
